import $ from 'jquery'
import { axiosInstance as axios, handleAxiosErrors } from '_utils'
import config from 'store/_config'
import _ from 'lodash'
import moment from 'moment'
import { createAlert } from '../dom/window'
import { requestUnpaidInvoices } from './invoicesActions'
import { getPaymentGateway, getCardId, getInvoicePaymentMethod } from '../selectors/defaultSelectors'

export const togglePaymentsLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PAYMENTS_LOADING',
      value: value,
    })
  }
}
export const togglePaymentLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PAYMENT_LOADING',
      value: value,
    })
  }
}
export const togglePaymentsButtonLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PAYMENT_BUTTON_LOADING',
      value: value,
    })
  }
}

// TODO: integrate
export const requestPayment = (order) => {
  return (dispatch, getState) => {
    const state = getState()
    const invoiceModal = document.getElementById('view-invoice-modal')
    const { user } = state.user
    let { url, query } = config.orders.details
    query = query.replace(/{userID}/, user).replace(/{orderID}/, order)

    $(invoiceModal).modal('show')

    dispatch(selectPayment(order))

    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query: query,
        },
      })
      .then((response) => {
        console.log(response.data)
        // const orders = convertPaymentsDetailsToAReadableFormat(response.data.data.readElvantiOrders.edges);
        // dispatch(updatePayments(orders));
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const selectPayment = (order) => {
  return {
    type: 'SELECT_PAYMENT',
    order: order,
  }
}

// pay invoice
export const reCalculatePaymentSurcharge = (params) => {
  return async (dispatch, getState) => {
    const { url, query } = config.payments.applyInvoiceCreditCardSurcharge

    const state = getState()
    const isLoading = state.payments.buttonLoading
    const { selectedCreditCard, selectedPaymentMethod } = state.payments.details
    let { isCustomAmount, selectedInvoiceIDs, amount } = params

    if (amount === '') {
      amount = '0'
    }

    const savedCardID = getCardId(selectedPaymentMethod, selectedCreditCard)

    let postData = {
      SavedCardID: savedCardID,
      Amount: parseFloat(amount, 10).toFixed(2) || 0,
      PaymentMethod: getInvoicePaymentMethod(selectedPaymentMethod),
    }

    if (!isCustomAmount) {
      postData.InvoiceIDs = selectedInvoiceIDs
    }

    // if (!postData.SavedCardID || isLoading) {
    //   dispatch(handleFieldUpdate('totalDue', 0))
    //   dispatch(handleFieldUpdate('totalSurcharge', 0))
    //   dispatch(handleFieldUpdate('total', parseFloat(amount, 10)))
    //   return
    // }

    if (!postData.Amount || postData.Amount === '0.00') {
      dispatch(handleFieldUpdate('totalDue', 0))
      dispatch(handleFieldUpdate('totalSurcharge', 0))
      dispatch(handleFieldUpdate('total', 0))
      return
    }

    try {
      dispatch(togglePaymentsButtonLoading(true))
      const response = await axios.post(url, {
        query,
        variables: postData,
      })

      const payResponse = response?.data?.data?.applyInvoiceCreditCardSurcharge

      dispatch(handleFieldUpdate('totalDue', payResponse?.TotalDue))
      dispatch(handleFieldUpdate('totalSurcharge', payResponse?.TotalSurcharge))
      dispatch(handleFieldUpdate('total', payResponse?.Total))

      dispatch(togglePaymentsButtonLoading(false))
    } catch (error) {
      handleAxiosErrors(error)
      dispatch(togglePaymentsButtonLoading(false))
    }
  }
}

export const makeAPayment = (params, callback = {}) => {
  return (dispatch, getState) => {
    const state = getState()
    const isLoading = state.payments.buttonLoading
    const { selectedCreditCard, selectedPaymentMethod } = state.payments.details
    const { isCustomAmount, selectedInvoiceIDs, amount } = params

    const gateway = getPaymentGateway(selectedPaymentMethod)

    let postData = {
      CardID: Number(selectedCreditCard),
      Amount: Number(amount),
      Gateway: gateway,
      PaymentMethod: getInvoicePaymentMethod(selectedPaymentMethod),
    }

    if (!isCustomAmount) {
      postData.InvoiceIDs = selectedInvoiceIDs
    }

    if (!amount) return
    if (isLoading) return

    dispatch(togglePaymentsButtonLoading(true))

    console.log(postData)

    return axiosMakeAPayment(postData)
      .then((response) => {
        dispatch(togglePaymentsButtonLoading(false))

        if (response?.data?.data?.payForParamountInvoices) {
          const { PaymentRedirectURL } = response.data.data.payForParamountInvoices?.[0]

          if (PaymentRedirectURL) {
            window.location.href = PaymentRedirectURL
            return
          }

          createAlert({ message: 'Invoice(s) has been paid' }, 'success')

          dispatch(handleFieldUpdate('totalDue', 0))
          dispatch(handleFieldUpdate('totalSurcharge', 0))
          dispatch(handleFieldUpdate('total', 0))

          if (isCustomAmount) {
          } else {
            // Re-request
            dispatch(requestUnpaidInvoices())
          }

          if (callback.success) {
            callback.success()
          }
        }
      })
      .catch((error) => {
        handleAxiosErrors(error)

        if (callback.error) {
          callback.error()
        }
      })
      .then(() => {
        dispatch(togglePaymentsButtonLoading(false))
      })
  }
}
/**
 * AXIOS call to make a payment
 *
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const axiosMakeAPayment = (params) => {
  let { url, query } = config.payments.makeapayment

  return axios.post(
    url,
    {
      query: query,
      variables: params,
    },
    {
      // withCredentials: true
    }
  )
}

export const axiosApplyInvoiceCreditCardSurcharge = (params) => {
  let { url, query } = config.payments.applyInvoiceCreditCardSurcharge

  return axios.post(
    url,
    {
      query: query,
      variables: params,
    },
    {
      // withCredentials: true
    }
  )
}

export const requestPaymentsHistory = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { user } = state.user
    let { url, query } = config.payments.listing
    query = query.replace('{userID}', user)

    dispatch(togglePaymentsLoading(true))

    return axios
      .get(url, {
        withCredentials: true,
        params: {
          query: query,
        },
      })
      .then((response) => {
        const orders = convertPaymentsToAReadableFormat(response.data.data.readSilverStripePayments.edges)
        dispatch(updatePayments(orders))
        dispatch(togglePaymentsLoading(false))
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const updatePayments = (list) => {
  return {
    type: 'UPDATE_PAYMENTS',
    list: _.keyBy(list, 'id'),
  }
}
export const updateSelectedCreditCard = (key, value) => {
  return (dispatch, getState) => {
    dispatch(handleFieldUpdate(key, value))
  }
}
export const convertPaymentsToAReadableFormat = (list) => {
  let newList = []
  list.map((item) => {
    const { ID, TransactionReference, Created, Amount, Status } = item.node

    if (Status == 'Captured' || Status == 'Authorized') {
      newList.push({
        id: ID,
        reference: TransactionReference || 'n/a',
        date_paid: moment(new Date(Created)).format('DD/MM/YYYY'),
        total: Number(Amount),
        status: Status,
      })
    }
  })
  return newList
}
export const convertPaymentsDetailsToAReadableFormat = (list) => {
  let newList = []
  list.map((item) => {
    const { ID, Reference, InvoiceDate, Paid, Total, Status } = item.node
    newList.push({
      id: ID,
      reference: Reference || 'n/a',
      date_paid: moment(new Date(InvoiceDate)).format('DD/MM/YYYY'),
      paid: Number(Paid),
      total: Number(Total),
      status: Status,
    })
  })
  return newList
}
export const handleFieldUpdate = (key, value) => {
  return {
    type: 'UPDATE_PAYMENTS_DETAILS',
    key: key,
    value: value,
  }
}
export const handleFieldUpdatePayment = (key, value) => {
  return {
    type: 'UPDATE_PAYMENTS_DETAILS_PAYMENT',
    key: key,
    value: value,
  }
}
